import React from 'react';
import TeamContactsView from '../components/TeamContactsView';

const Contacts: React.FC = () => {
  return <TeamContactsView />;
};

export default Contacts;

